/*
 * @Author: Liux
 * @Date: 2019-12-20 02:18:57
 * @LastEditor: Liux
 * @LastEditTime: 2020-08-13 00:50:54
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdDropdownListComponent } from './ad-dropdown-list.component';
import { AdCheckBoxModule } from '../ad-check-box/ad-check-box.module';
import { AdTextModule } from '../ad-text/ad-text.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [AdDropdownListComponent],
  imports: [
    CommonModule,
    AdCheckBoxModule,
    AdTextModule,
    FormsModule,
    ScrollingModule,
  ],
  exports: [AdDropdownListComponent, FormsModule],
})
export class AdDropdownListModule {}

export { AdDropdownListComponent };
